module.exports = __webpack_public_path__ + "static/media/palmTree.c701d7b3.png";